import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { deliverables } from '../../data/content';
export function Deliverables() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:py-20" data-id="element-131" data-mp="106g69hnyb6i8">
      <div className="mx-auto w-full max-w-5xl" data-id="element-132" data-mp="mejl5xkp9wvc">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-133" data-mp="mbxbnse917ah">
          📲 ¿Qué recibes inmediatamente después de comprar?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy-100/75 sm:text-lg" data-id="element-134" data-mp="1e33ggm4wzt63">
          Desde el momento en que completes tu compra tendrás acceso inmediato a
          un sistema diseñado para acompañarte en cada decisión clínica
          relacionada con el hipotiroidismo.
        </p>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-135" data-mp="3puqkxszzv9yu">
          {deliverables.map(item => <li key={item.title} className="rounded-3xl border border-white/10 bg-white/5 p-5 sm:p-6" data-id="element-136" data-mp="3uta6hsaoejqo">
              <span className="text-3xl" aria-hidden="true" data-id="element-137" data-mp="eeo9uylscuht">
                {item.emoji}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold leading-snug text-white sm:text-xl" data-id="element-138" data-mp="9gw7fanilpzd">
                {item.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy-100/75 sm:text-base" data-id="element-139" data-mp="jcptbkn4ivtt">
                {item.text}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-lg font-bold leading-snug text-white sm:text-2xl" data-id="element-140" data-mp="sdxi9c3r2kb8">
          Porque cada paciente es diferente…
          <span className="mt-1 block text-navy-300" data-id="element-141" data-mp="174wju36648lb">
            Ruta Hipotiroidismo™ te muestra exactamente qué hacer con cada uno
            de ellos.
          </span>
        </p>

        <TransformCTA variant="dark" headline="En 2 minutos puedes tenerlo todo descargado en tu celular." data-id="element-142" data-mp="1g41fn1qchnts" />
      </div>
    </section>;
}